import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop,
  TextField,
  Button,
  Typography,
} from 'rmwc';
import { enroll } from '../actions/onboardingActions';
import { Text } from './Text';
import { logEvent } from '../helpers/analytics';

export const EmailDialog = connect()(
  class extends Component {
    state = { email: '' };

    onSave = () => {
      const { dispatch, onAccept } = this.props;

      dispatch(enroll(this.state)).then(onAccept);
    };

    onChange = event => {
      this.setState({
        [event.target.name]: event.target.value,
      });
    };

    canContinue = () => {
      const { email } = this.state;

      return email && email.indexOf('@') > 0 && email.indexOf('@') < email.length - 1;
    };

    emailField = () => (
      <TextField
        className="hrbr-input-wide"
        type="text"
        name="email"
        value={this.state.email}
        label="E-mail Address"
        onChange={this.onChange}
      />
    );

    variantCopy = {
      PDF_EMAIL: {
        title: 'Download your plan today!',
        submitButton: 'Continue',
        cancelButton: 'Cancel',
      },
    };

    render() {
      const { variant } = this.props;
      let title,
        submitButton,
        cancelButton = '';
      if (variant != null) {
        title = this.variantCopy[variant].title;
        submitButton = this.variantCopy[variant].submitButton;
        cancelButton = this.variantCopy[variant].cancelButton;
      }

      return (
        <Dialog open={this.props.open} onAccept={this.onSave} onCancel={this.props.onCancel}>
          <DialogSurface className="hrbr-dialog-small">
            <DialogHeader>
              <DialogHeaderTitle>{title}</DialogHeaderTitle>
            </DialogHeader>
            <DialogBody className="pb-2">
              {variant == 'PDF_EMAIL' && (
                <Fragment>
                  <Typography tag="div" use="body1">
                    Tell us your e-mail address so we can send you your plan.
                  </Typography>
                  {this.emailField()}
                </Fragment>
              )}
            </DialogBody>
            <DialogFooter>
              <DialogFooterButton cancel>{cancelButton}</DialogFooterButton>
              <DialogFooterButton accept unelevated theme="secondary-bg on-secondary" disabled={!this.canContinue()}>
                {submitButton}
              </DialogFooterButton>
            </DialogFooter>
            <Typography
              use="caption"
              theme="text-secondary-on-background"
              tag="div"
              style={{ textAlign: 'right', margin: '0 1rem 0.5rem 0' }}
            >
              We value your privacy and will never spam you.
            </Typography>
          </DialogSurface>
          <DialogBackdrop />
        </Dialog>
      );
    }
  }
);

export function withEmailDialog(WrappedComponent) {
  return class extends Component {
    state = { open: false, variant: null };

    onOpen = (afterAccept, afterClose, variant) => {
      logEvent('EmailOpened', {
        variant: variant,
      });
      this.setState({ open: true, variant, afterClose, afterAccept });
    };

    onCancel = () => {
      logEvent('EmailCancelled', {
        variant: this.state.variant,
      });
      this.setState({ open: false }, this.state.afterClose);
    };

    onAccept = () => {
      logEvent('EmailAccepted', {
        variant: this.state.variant,
      });
      this.setState({ open: false }, this.state.afterAccept);
    };

    withEmailGuard = (user, action) => {
      return () => {
        if (user.is_guest) {
          this.onOpen(action, () => {}, 'REQUIRED_EMAIL');
        } else {
          action();
        }
      };
    };

    render() {
      return (
        <div>
          <WrappedComponent openEmailDialog={this.onOpen} withEmailGuard={this.withEmailGuard} {...this.props} />
          <EmailDialog
            open={this.state.open}
            variant={this.state.variant}
            onCancel={this.onCancel}
            onAccept={this.onAccept}
          />
        </div>
      );
    }
  };
}
